import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  Input,
  Renderer2,
  ElementRef,
  SimpleChanges,
  HostListener,
} from "@angular/core";
import { PanierService } from "src/app/services/manage/panier/panier.service";
import { Router } from "@angular/router";
import { ToolsService } from "src/app/services/tools/tools.service";
import { DialogsService } from "src/app/services/manage/dialogs/dialogs.service";
import { MatButton } from "@angular/material/button";
import { fromEvent } from "rxjs";
import { map, tap, filter, debounceTime } from "rxjs/operators";
import { FormGroup, FormBuilder } from "@angular/forms";
import {CssService} from "../../../../services/css-service";
import {SalemethodService} from "../../../../services/api/salemethod/salemethod.service";

@Component({
  selector: "app-handle-sidenav",
  templateUrl: "./handle-sidenav.component.html",
  styleUrls: ["./handle-sidenav.component.css"],
})
export class HandleSidenavComponent implements OnInit {
  @ViewChild("basketBtn") basketBtn: MatButton | any;
  @ViewChild("searchInput") searchInput: ElementRef | any;

  @Input()
  user$: any;
  @Input() merchantClient$: any;

  @Input()
  products$: any;

  @Input()
  searchProductLoader: boolean | any;

  @Input()
  toggleBasket: boolean | any;

  @Input()
  showSearchInput: boolean | any;
  @Input()
  closeSearch:any;

  @Output()
  setShowSearchInputEvent = new EventEmitter<any>();

  @Output()
  setSearchProductLoaderEvent = new EventEmitter<any>();


  @Output()
  setFindedProductsEvent = new EventEmitter<any>();

  @Output()
  goNextPageEvent = new EventEmitter<any>();

  @Output()
  goPreviousPageEvent = new EventEmitter<any>();

  @Output()
  openBasketEvent = new EventEmitter<any>();

  searchProductForm: FormGroup | any;

  basket$: any[] = [];

  totalPricePan: number | any;
  popClosed: boolean = true;

  @Output()
  searchProductEvent = new EventEmitter<any>();
  @Output()
  resetSearchProductEvent = new EventEmitter<any>();

  constructor(
    private panierMan: PanierService,
    private router: Router,
    public tools: ToolsService,
    public cssService: CssService,
    private myDials: DialogsService,
    private renderer: Renderer2,
    private formBuilder: FormBuilder
  ) { }







  ngOnInit() {

    /**
     * Souscription au panier
     */
    this.panierMan.getPanier.subscribe((basket) => {

      this.basket$ = basket;
      this.totalPricePan = this.merchantClient$ && this.merchantClient$.id_group && (this.merchantClient$.discount || this.merchantClient$.groups_discount) ?
        this.panierMan.getTotalAfterDiscount(this.merchantClient$) : this.panierMan.getPrice();


    });

    /**
     * Création du formulaire de recherche de produit
     */
    this.createSearchProductForm();
  }

  ngOnChanges(changes: SimpleChanges): void {


    if (changes && changes['merchantClient$']) {
      this.merchantClient$ = changes['merchantClient$'].currentValue;
      this.ngOnInit();
    }



    if(changes && changes['closeSearch'] && changes['closeSearch'].currentValue){
      setTimeout(() => {
        this.searchProductForm.get("searchProductInput").setValue('');  this.setShowSearchInput(false); this.resetSearchProductEvent.emit();
      }, 0);

    }


  }

  /**
   * @description Fonction Output redirigeant vers la page indiqué dans l'élément parent
   * @returns {void}
   */
  goNextPage(): void {
    this.goNextPageEvent.emit();
  }

  /**
   * @description Fonction Output redirigeant vers la page indiqué dans l'élément parent
   * @returns {void}
   */
  goPreviousPage(): void {
    this.goPreviousPageEvent.emit();
  }

  /**
   * @description Redirige vers la page endorder
   * @returns {void}
   */
  goEndOrder(): void {


    if (this.basket$.length < 1) {
      this.animBasketBtn();
    } else {
      const currSm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
      this.totalPricePan < currSm.minimum_order
        ? this.myDials.openMiniAmountDial()
        : this.router.navigate(["/endorder"]);
    }
  }

  /**
   * @description Redirige vers la page produit
   * @returns {void}
   */
  goProduct(): void {

    this.tools.goProductPage();
  }

  /**
   * @description Anime le bouton du panier
   * @returns {void}
   */
  animBasketBtn(): void {
    this.renderer.removeClass(
      this.basketBtn._elementRef.nativeElement,
      "animAlert"
    );
    setTimeout(() => {
      this.renderer.addClass(
        this.basketBtn._elementRef.nativeElement,
        "animAlert"
      );
    });
  }

  /**
   * @description Crée un formulaire angular pour la recherche de produit
   * @returns {void}
   */
  createSearchProductForm(): void {
    this.searchProductForm = this.formBuilder.group({
      searchProductInput: [""],
    });
    this.searchInputEvent();
  }

  /**
   * @description Show l'input de recherche + focus
   * @returns {void}
   */
  openSearchInput(): void {
    this.setShowSearchInput(true);
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    });
  }

  /**
   * @description Evenement onKeyUp sur l'input de recherche de produit
   * @returns {void}
   */



  searchInputEvent(): void {

    let time = 0

    this.searchProductForm.get("searchProductInput").valueChanges.subscribe((selectedValue: any) => {

      if (!time) {
        time = 1;
        setTimeout(() => {
          if (this.searchProductForm.get("searchProductInput").value && this.searchProductForm.get("searchProductInput").value.length > 2&&this.searchProductForm.get("searchProductInput").value.trim().length>0) {

            this.searchProductEvent.emit(this.searchProductForm.get("searchProductInput").value);
          }
          else if (
            !this.searchProductForm.get("searchProductInput").value || this.searchProductForm.get("searchProductInput").value && this.searchProductForm.get("searchProductInput").value.trim().length == 0
          ) {

            //reset
            this.resetSearchProductEvent.emit();

          }
          time = 0;
        }, 1500);
      }


    });


  }

  /**
   *  @description Set le tableau des produits trouvés via la recherche
   *  @returns {void}
   */
  setFindedProducts(value: any): void {
    this.setFindedProductsEvent.emit(value);
  }

  /**
   *  @description Set le tableau des produits trouvés via la recherche
   *  @returns {void}
   */
  setShowSearchInput(value: any): void {


    this.setShowSearchInputEvent.emit(value);
  }

  /**
   *  @description Set le loader de recherche produit
   *  @returns {void}
   */
  setSearchProductLoader(value: boolean) {
    this.setSearchProductLoaderEvent.emit(value);
  }



  /**
   * @description Gère l'affichage du basket en mode lt-lg
   */
  openBasket(): void {

    this.openBasketEvent.emit();
  }

}
